import { useNavigate, useParams } from "react-router-dom";
import { useStore } from "../../../Components/StateProvider";
import React, { useEffect, useState } from "react";
import { FaEye, FaEyeSlash } from "react-icons/fa6";

import * as XLSX from "xlsx";
import { jsPDF } from "jspdf";
import {
  baseurl,
  ErrorAlert,
  GetDateTimeFormat,
  GetRecords,
  RupeeFormat,
  UploadFile,
  URLPRIFIX,
  WarningAlert,
} from "../../../functions/api";
import AccountsLayout from "../AccountsLayout";
import FormView from "../../../Components/Elements/FormView";
import { MdOutlineFileUpload } from "react-icons/md";
import { FaRegEye } from "react-icons/fa6";
import { HiOutlineArrowSmDown, HiOutlineArrowSmUp } from "react-icons/hi";
import { URL_Account_TDSReport } from "../../../Constancs/apiconst";
import LoadingSpinner from "../../../Components/Elements/LoadingSpinner";

const Reconciliation = () => {
  const { companyId } = useParams();
  const navigate = useNavigate();
  const store = useStore();

  const init = {
    ToDate: "",
  };

  const initProps = {
    add: false,
    delete: false,
    on_off: false,
    print: false,
    update: false,
    view: false,
    ToDate: {},
  };

  const [Record, setRecord] = useState(init);
  const [props, setprops] = useState(initProps);

  // States
  const [ledgerData, setLedgerData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [expandedInvoice, setExpandedInvoice] = useState(null);

  // Load initial values
  useEffect(() => {
    store.setmodule("reconciliation", initProps);
    const dateTime = GetDateTimeFormat();

    handleMultiFieldChange({
      fromDate: dateTime.yearStartDate + "Z",
      ToDate: dateTime.DBFormat.substring(0, 10) + "T00:00:00Z",
    });

    loadRecord();
  }, []);

  // Function to load records
  const loadRecord = async (fromDate, ToDate) => {
    try {
      const response =
        await GetRecords(`/api/v2/accounting/reconciliation/${companyId}??startDate=${
          fromDate || Record.fromDate
        }
                &endDate=${ToDate || Record.ToDate}`);
      console.log("to date", ToDate);

      if (response.success) {
        setLedgerData(response.record);
      } else {
        setLoading(true);
      }
    } catch (err) {
      setError("Error fetching data");
    } finally {
      setLoading(false);
    }
  };

  // *Handle Fields changes in Record States
  function handleFieldChange(fieldName, value) {
    setRecord((prev) => {
      return { ...prev, [fieldName]: value };
    });
  }
  function handleMultiFieldChange(value = {}) {
    setRecord((prev) => {
      for (let fieldName in value) {
        prev[fieldName] = value[fieldName];
      }
      return { ...prev };
    });
  }

  useEffect(() => {
    console.log("Props State change -> ", props);
  }, [props]);

  // Toggle invoice expand
  const toggleExpand = (invoiceId) => {
    setExpandedInvoice(expandedInvoice === invoiceId ? null : invoiceId);
  };

  if (loading) return <LoadingSpinner />;
  if (error) return <p className="text-center p-5 text-red-600">{error}</p>;

  return (
    <>
      <div className="flex px-10 py-1 bg-secondary rounded-lg gap-3 justify-between border-b border-Old_Silver">
        <div // ToDate
          className={
            "flex text-[14px] w-full h-full px-3 flex-row items-center justify-center gap-3 " +
            (props.ToDate.hidden ? " hidden " : " flex ")
          }
        >
          <label className={"w-fit  min-w-[100px] max-w-full"}>
            As of Date
            {props.ToDate.mandatory && (
              <span className="text-[#ff2828] text-[14px] h-fit">*</span>
            )}
          </label>
          <input
            className={
              "w-[250px] border-b border-Old_Silver border-opacity-35 font-medium disabled:bg-[#c6c6ca]   text-black disabled:bg-opacity-20 px-2 py-1 " +
              (props.ToDate.mandatory && props.ToDate.show
                ? " rounded-2xl border-2 border-[#ff2828] "
                : "")
            }
            id={"ToDate"}
            type="date"
            value={Record.ToDate.split("T")[0]}
            disabled={props.ToDate.readonly}
            onChange={(event) => {
              handleFieldChange("ToDate", event.target.value + "T00:00:00Z");
              loadRecord(Record.fromDate, event.target.value + "T00:00:00Z");
            }}
          />
        </div>
        {/* <div className="flex gap-5">
          <button
            className={
              "py-2 px-6 rounded-xl font-bold text-[12px]  bg-primary text-secondary"
            }
            // onClick={ExportExcel}
          >
            EXCEL
          </button>
          <button
            className={
              "py-2 px-6 rounded-xl font-bold text-[12px]  bg-primary text-secondary"
            }
            // onClick={ExportPDF}
          >
            PDF
          </button>
        </div> */}
      </div>
      {loading ? (
        <LoadingSpinner />
      ) : error ? (
        <p className="text-center p-5 text-red-600">{error}</p>
      ) : (
        <div className="p-5 bg-gray-100 min-h-screen">
          {/* <h1 className="text-2xl font-bold text-center mb-5">Reconciliation Ledger</h1> */}
          <div className="bg-white p-4 rounded-lg shadow-lg overflow-x-auto">
            <table className="w-full border-collapse border border-gray-300">
              <thead>
                <tr className="bg-Azureish_White">
                  <th className="border p-2">Date</th>
                  <th className="border p-2">Invoice No</th>
                  <th className="border p-2">Status</th>
                  <th className="border p-2">Debit (₹)</th>
                  <th className="border p-2">Credit (₹)</th>
                  <th className="border p-2">Balance (₹)</th>
                  <th className="border p-2">Actions</th>
                </tr>
              </thead>
              <tbody>
                {ledgerData.map((entry) => (
                  <React.Fragment key={entry.invoiceId}>
                    {/* Invoice Row (Debit) */}
                    <tr className="text-center bg-red-100">
                      <td className="border p-2">
                        {new Date(entry.invoiceDate).toLocaleDateString()}
                      </td>
                      <td className="border p-2 ">{entry.invoiceNo}</td>
                      <td className="border p-2 ">{entry.status}</td>
                      <td className="border p-2 text-[#a10906]">
                        {RupeeFormat(entry.invoiceAmount)}
                      </td>
                      <td className="border p-2">-</td>
                      <td className="border p-2">
                        {RupeeFormat(
                          entry.invoiceAmount - (entry.totalPaid || 0)
                        )}
                      </td>
                      <td className="border p-2">
                        <button
                          className="bg-blue-500 text-white px-2 py-1 rounded flex items-center gap-3"
                          onClick={() => toggleExpand(entry.invoiceId)}
                        >
                          {expandedInvoice === entry.invoiceId ? (
                            <FaEyeSlash />
                          ) : (
                            <FaEye />
                          )}
                        </button>
                      </td>
                    </tr>

                    {/* Payment Rows (Credits) */}
                    {expandedInvoice === entry.invoiceId &&
                      entry.payments &&
                      entry.payments.map((payment) => (
                        <tr
                          key={payment.paymentId}
                          className="text-center bg-[#DCDCDC] text-[#000000] text-center"
                        >
                          <td className="border p-2">
                            {new Date(payment.receiptDate).toLocaleDateString()}
                          </td>
                          <td className="border p-2">{payment.receiptNo}</td>
                          <td className="border p-2">-</td>
                          <td className="border p-2">-</td>
                          <td className="border p-2 ">
                            {RupeeFormat(payment.paymentAmount)}
                          </td>
                          <td className="border p-2">-</td>
                          <td className="border p-2">-</td>
                        </tr>
                      ))}
                  </React.Fragment>
                ))}

                {/* Total Row */}
                <tr className="bg-Azureish_White font-bold text-center">
                  <td colSpan="3" className="border p-2">
                    Total
                  </td>
                  <td className="border p-2 text-red-600">
                    ₹
                    {RupeeFormat(
                      ledgerData.reduce(
                        (acc, cur) => acc + (cur.invoiceAmount || 0),
                        0
                      )
                    )}
                  </td>
                  <td className="border p-2 text-green-600">
                    ₹
                    {RupeeFormat(
                      ledgerData.reduce(
                        (acc, cur) => acc + (cur.totalPaid || 0),
                        0
                      )
                    )}
                  </td>
                  <td className="border p-2">
                    ₹
                    {RupeeFormat(
                      ledgerData.reduce(
                        (acc, cur) =>
                          acc + (cur.invoiceAmount || 0) - (cur.totalPaid || 0),
                        0
                      )
                    )}
                  </td>
                  <td className="border p-2">-</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      )}
    </>
  );
};

export default Reconciliation;
